import { useAuth } from 'react-oidc-context';
import { useMemo } from 'react';

export interface AuthUser {
  sub: string;
  email: string | null;
  name: string | null;
  tenantId: string | null;
  roles: ReadonlyArray<string>;
  modules: ReadonlyArray<string>;
}

interface JwtClaims {
  sub: string;
  email?: string;
  name?: string;
  preferred_username?: string;
  tenant_id?: string;
  roles?: string[];
  modules?: string[];
  realm_access?: { roles?: string[] };
}

export function useAuthUser(): AuthUser | null {
  const auth = useAuth();
  return useMemo(() => {
    if (!auth.isAuthenticated || !auth.user) return null;
    const claims = auth.user.profile as unknown as JwtClaims;
    const realmRoles = claims.realm_access?.roles ?? [];
    const customRoles = claims.roles ?? [];
    const allRoles = Array.from(new Set([...realmRoles, ...customRoles]));
    return {
      sub: claims.sub,
      email: claims.email ?? null,
      name: claims.name ?? claims.preferred_username ?? null,
      tenantId: claims.tenant_id ?? null,
      roles: allRoles,
      modules: claims.modules ?? [],
    };
  }, [auth.isAuthenticated, auth.user]);
}
